export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9375.831c2ef3.jpg";